import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel, CardHeader,
  MenuItem, TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TablePagination, Paper
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { trackPromise } from 'react-promise-tracker';
import { Formik } from 'formik';
import * as Yup from "yup";
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { useNavigate } from 'react-router-dom';
import { useAlert } from "react-alert";
import { startOfMonth, endOfMonth, addMonths } from 'date-fns';
import DateRangeSelectorComponent from '../../InquiryRegistry/Utils/DateRangeSelector';
import Popover from '@material-ui/core/Popover';
import EventIcon from '@material-ui/icons/Event';
import xlsx from 'json-as-xlsx';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorRecord: {
    backgroundColor: "green",
  },
}));
const getPageMargins = () => {
  return `@media print {
          @page {
          size: A4 Landscape !important;
          background-color: white !important;
      }
      body {
          transform-origin: top left;
          background-color: white !important;
      }
  }`;
};
const screenCode = 'EARLYSETTLEDLOANREPORT';

export default function EarlySettledLoanReport(props) {
  const [title, setTitle] = useState("Loan Settled Report");
  const classes = useStyles();
  const [GroupList, setGroupList] = useState([]);
  const [FactoryList, setFactoryList] = useState([]);
  const [routeList, setRouteList] = useState();
  const [loanRequestDetail, setLoanRequestDetail] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    settlementType: 0,
    registrationNumber: ''
  });
  const [earlySettledLoanList, setEarlySettledLoanList] = useState([]);
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: "0",
    factoryName: "0",
    settlementType: "0",
    startDate: new Date(),
    endDate: new Date(),
    routeName: '',
    registrationNumber: ''
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
  });
  const navigate = useNavigate();
  const alert = useAlert();
  const componentRef = useRef();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClickPop = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const [DateRange, setDateRange] = useState({
    startDate: startOfMonth(addMonths(new Date(), -5)),
    endDate: endOfMonth(addMonths(new Date(), -0))
  });
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const [csvHeaders, SetCsvHeaders] = useState([])
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    trackPromise(
      getPermission());
    trackPromise(
      getGroupsForDropdown());
  }, []);

  useEffect(() => {
    trackPromise(
      getFactoriesForDropdown());
  }, [loanRequestDetail.groupID]);

  useEffect(() => {
    trackPromise(
      getRoutesByFactoryID());
  }, [loanRequestDetail.factoryID]);

  async function getPermission() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWEARLYSETTLEDLOANREPORT');

    if (isAuthorized === undefined) {
      navigate('/404');
    }
    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
    });

    setLoanRequestDetail({
      ...loanRequestDetail,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken())
    })
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroupList(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getFactoryByGroupID(loanRequestDetail.groupID);
    setFactoryList(factories);
  }

  async function getRoutesByFactoryID() {
    const routes = await services.getRoutesForDropDown(loanRequestDetail.factoryID);
    setRouteList(routes);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    setPage(0);
  };

  async function GetEarlySettledLoanDetails() {
    let model = {
      groupID: parseInt(loanRequestDetail.groupID),
      factoryID: parseInt(loanRequestDetail.factoryID),
      routeID: parseInt(loanRequestDetail.routeID),
      settlementType: selectedSearchValues.settlementType,
      registrationNumber: loanRequestDetail.registrationNumber === null ? "" : loanRequestDetail.registrationNumber,
      startDate: moment(DateRange.startDate.toString()).format().split('T')[0],
      endDate: moment(DateRange.endDate.toString()).format().split('T')[0],
    }
    const response = await services.GetEarlySettledLoanDetails(model);

    getSelectedDropdownValuesForReport(model);

    if (response.statusCode == "Success" && response.data != null) {
      setEarlySettledLoanList(response.data);
      createDataForExcel(response.data);

      if (response.data.length == 0) {
        alert.error("No records to display");
      }
    }
    else {
      alert.error(response.message);

    }
  }

  async function createDataForExcel(array) {
    var res = [];

    if (array != null) {
      array.map(x => {
        const isDefaultDate = (date) => {
          return (
            !date ||
            date === "0001-01-01T00:00:00" ||
            moment(date).year() === 1
          );
        };
        var vr = {
          'Route Name': x.routeName,
          'Reg No': x.registrationNumber,
          'Name': x.customerName,
          'Loan Issue Date': x.loanIssuedDate.split('T')[0],
          'Settled Date': isDefaultDate(x.earlySettledDate)
            ? '-'
            : moment(x.earlySettledDate).format('DD/MM/YYYY'),
          'Payment Compleated Date': isDefaultDate(x.paymentCompleatedDate)
            ? '-'
            : moment(x.paymentCompleatedDate).format('DD/MM/YYYY'),
          'Annual Rate': x.annualRate,
          'No. of Installments': x.numberOfInstalments,
          'No. of Completed Installment': x.numberOfCompletedInstalments,
          'Loan Amount (Rs)': x.principalAmount,
          'Fine Interest (%)': x.earlyStettleFineInterest,
          'Early Settled Amount (Rs)': x.capitalOutstanding,
          'Fine Amount (Rs)': x.earlySettlementFine,
        }
        res.push(vr);
      });
      res.push({});
      var vr = {
        'Route Name': "Group :" + selectedSearchValues.groupName,
        'Reg No': "Factory :" + selectedSearchValues.factoryName,
      }
      res.push(vr);
      var vr = {
        'Route Name': "Route :" + (selectedSearchValues.routeName === undefined ? "All Routes" : selectedSearchValues.routeName),
        'Reg No': "Date :" + moment(DateRange.startDate).format("YYYY/MM/DD") + "-" + moment(DateRange.endDate).format("YYYY/MM/DD"),
      }
      res.push(vr);
      var vr = {
        'Route Name': "Reg No :" + (selectedSearchValues.registrationNumber === "" ? "All Reg. No" : selectedSearchValues.routeName),
      }
      res.push(vr);
    }

    return res;
  }

  async function createFile() {

    var file = await createDataForExcel(earlySettledLoanList);
    var settings = {
      sheetName: 'Loan Settled Report',
      fileName: 'Loan Settled Report - ' + selectedSearchValues.groupName + ' - ' + selectedSearchValues.factoryName + ' '
        + moment(DateRange.startDate).format("YYYY/MM/DD") + ' - ' + moment(DateRange.endDate).format("YYYY/MM/DD"),
      writeOptions: {}
    }

    let keys = Object.keys(file[0])
    let tempcsvHeaders = csvHeaders;
    keys.map((sitem, i) => {
      tempcsvHeaders.push({ label: sitem, value: sitem })
    })

    let dataA = [
      {
        sheet: 'Loan Settled Report',
        columns: tempcsvHeaders,
        content: file
      }
    ]

    xlsx(dataA, settings);
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
      }
    }
    return items;
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setLoanRequestDetail({
      ...loanRequestDetail,
      [e.target.name]: value
    });
    setEarlySettledLoanList([]);
  }

  function handleSettleChange(e) {
    const target = e.target;
    const value = target.value;
    setSelectedSearchValues({
      ...selectedSearchValues,
      [e.target.name]: value
    });
  }

  function getSelectedDropdownValuesForReport(searchForm) {
    var startDate = moment(searchForm.startDate.toString()).format().split('T')[0]
    var endDate = moment(searchForm.endDate.toString()).format().split('T')[0]
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: GroupList[searchForm.groupID],
      factoryName: FactoryList[searchForm.factoryID],
      startDate: [startDate],
      endDate: [endDate],
      routeName: routeList[searchForm.routeID],
      registrationNumber: searchForm.registrationNumber
    })
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  return (
    <Fragment>
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: loanRequestDetail.groupID,
              factoryID: loanRequestDetail.factoryID
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required'),
              })
            }
            onSubmit={() => trackPromise(GetEarlySettledLoanDetails())}
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              touched
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader title={cardTitle(title)} />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={loanRequestDetail.groupID}
                              variant="outlined"
                              id="groupID"
                              disabled={!permissionList.isGroupFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(GroupList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={loanRequestDetail.factoryID}
                              variant="outlined"
                              id="factoryID"
                              disabled={!permissionList.isFactoryFilterEnabled}
                              size='small'
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(FactoryList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="routeID">
                              Route
                            </InputLabel>
                            <TextField select
                              fullWidth
                              name="routeID"
                              onChange={(e) => handleChange(e)}
                              value={loanRequestDetail.routeID}
                              variant="outlined"
                              id="routeID"
                              size='small'
                            >
                              <MenuItem value="0">--Select Route--</MenuItem>
                              {generateDropDownMenu(routeList)}
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="registrationNumber">
                              Registration Number
                            </InputLabel>
                            <TextField
                              error={Boolean(touched.registrationNumber && errors.registrationNumber)}
                              fullWidth
                              helperText={touched.registrationNumber && errors.registrationNumber}
                              name="registrationNumber"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={loanRequestDetail.registrationNumber}
                              variant="outlined"
                              id="registrationNumber"
                              size='small'
                            >
                            </TextField>
                          </Grid>
                          <Grid item md={3} xs={12}>
                            <InputLabel shrink id="settlementType">
                              Settlement Type
                            </InputLabel>
                            <TextField
                              select
                              fullWidth
                              name="settlementType"
                              onChange={e => handleSettleChange(e)}
                              value={selectedSearchValues.settlementType}
                              variant="outlined"
                              id="settlementType"
                              size="small"
                            >
                              <MenuItem value="0">Early Settled </MenuItem>
                              <MenuItem value="1">Month End  Settled </MenuItem>
                            </TextField>
                          </Grid>
                          <Grid item md={4} xs={12} >
                            <InputLabel shrink>
                              Date *
                            </InputLabel>
                            <Button
                              aria-describedby={id}
                              variant="contained"
                              fullWidth
                              color="primary"
                              onClick={handleClickPop}
                              size="medium"
                              endIcon={<EventIcon />}
                            >
                              {DateRange.startDate.toLocaleDateString() + " - " + DateRange.endDate.toLocaleDateString()}
                            </Button>
                            <Popover
                              id={id}
                              open={open}
                              anchorEl={anchorEl}
                              onClose={handleClose}
                              anchorOrigin={{
                                vertical: 'center',
                                horizontal: 'left',
                              }}
                              transformOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                              }}
                            >
                              <DateRangeSelectorComponent setDateRange={setDateRange} handleClose={handleClose} />
                            </Popover>
                          </Grid>
                        </Grid>
                        <Box display="flex" flexDirection="row-reverse" p={2} >
                          <Button
                            color="primary"
                            type="submit"
                            variant="contained"
                            size='small'
                          >
                            Search
                          </Button>
                        </Box>
                      </CardContent>
                      <Box minWidth={1050} margin={"10px"}>
                        {earlySettledLoanList.length > 0 ?
                          <TableContainer>
                            <Table aria-label="caption table" size="small" >  
                              <TableHead>
                                <TableRow>
                                  <TableCell align={'left'} style={{ border: "1px #ccc solid" }}>Route Name</TableCell>
                                  <TableCell align={'left'} style={{ border: "1px #ccc solid" }}>Reg No</TableCell>
                                  <TableCell align={'left'} style={{ border: "1px #ccc solid" }}>Name</TableCell>
                                  <TableCell align={'left'} style={{ border: "1px #ccc solid" }}>Loan Issue Date</TableCell>
                                  <TableCell align={'left'} style={{ border: "1px #ccc solid" }}>Settled Date</TableCell>
                                  <TableCell align={'left'} style={{ border: "1px #ccc solid" }}>Payment Completed Date</TableCell>
                                  <TableCell align={'left'} style={{ border: "1px #ccc solid" }}>Annual Rate</TableCell>
                                  <TableCell align={'right'} style={{ border: "1px #ccc solid" }}>No. of Installments</TableCell>
                                  <TableCell align={'right'} style={{ border: "1px #ccc solid" }}>No. of Completed Installment</TableCell>
                                  <TableCell align={'right'} style={{ border: "1px #ccc solid" }}>Loan Amount (Rs)</TableCell>
                                  <TableCell align={'right'} style={{ border: "1px #ccc solid" }}>Fine Interest (%)</TableCell>
                                  <TableCell align={'right'} style={{ border: "1px #ccc solid" }}>Early Settled Amount (Rs)</TableCell>
                                  <TableCell align={'right'} style={{ border: "1px #ccc solid" }}>Fine Amount (Rs)</TableCell>

                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {earlySettledLoanList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((data, index) => (
                                  <TableRow key={index}>
                                    <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                                      {data.routeName}
                                    </TableCell>
                                    <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                                      {data.registrationNumber}
                                    </TableCell>
                                    <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                                      {data.customerName}
                                    </TableCell>
                                    <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid", width: "115px" }}>
                                      {data.loanIssuedDate.split('T')[0]}
                                    </TableCell>
                                    <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid", width: "115px" }}>
                                      {
                                        data.earlySettledDate &&
                                          data.earlySettledDate !== "0001-01-01T00:00:00" &&
                                          moment(data.earlySettledDate).isValid()
                                          ? moment(data.earlySettledDate).format("DD/MM/YYYY")
                                          : "-"
                                      }
                                    </TableCell>
                                    <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid", width: "115px" }}>
                                      {
                                        data.paymentCompleatedDate &&
                                          data.paymentCompleatedDate !== "0001-01-01T00:00:00" &&
                                          moment(data.paymentCompleatedDate).isValid()
                                          ? moment(data.paymentCompleatedDate).format("DD/MM/YYYY")
                                          : "-"
                                      }
                                    </TableCell>
                                    <TableCell align={'left'} component="th" scope="row" style={{ border: "1px #ccc solid", width: "115px" }}>
                                      {data.annualRate}
                                    </TableCell>
                                    <TableCell align={'right'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                                      {data.numberOfInstalments}
                                    </TableCell>
                                    <TableCell align={'right'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                                      {data.numberOfCompletedInstalments}
                                    </TableCell>
                                    <TableCell align={'right'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                                      {data.principalAmount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </TableCell>
                                    <TableCell align={'right'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                                      {data.earlyStettleFineInterest.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </TableCell>
                                    <TableCell align={'right'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                                      {data.capitalOutstanding.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </TableCell>
                                      <TableCell align={'right'} component="th" scope="row" style={{ border: "1px #ccc solid" }}>
                                      {data.earlySettlementFine.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                    </TableCell>
                                  </TableRow>
                                ))}
                              </TableBody>
                            </Table>
                            {earlySettledLoanList.length > 0 && (<TablePagination
                              rowsPerPageOptions={[10, 20, 30]}
                              component="div"
                              count={earlySettledLoanList.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              onChangePage={handleChangePage}
                              onChangeRowsPerPage={handleChangeRowsPerPage}
                            />)}
                          </TableContainer> : null}
                      </Box>
                      {earlySettledLoanList.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="submit"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorRecord}
                            onClick={() => createFile()}
                            size='small'
                          >
                            EXCEL
                          </Button>
                          <ReactToPrint
                            documentTitle={"Loan Settled Report_" + moment(DateRange.startDate).format("YYYY/MM/DD") + " - " + moment(DateRange.endDate).format("YYYY/MM/DD")}
                            trigger={() => <Button
                              color="primary"
                              id="btnRecord"
                              type="submit"
                              variant="contained"
                              style={{ marginRight: '1rem' }}
                              className={classes.colorCancel}
                              size='small'
                            >
                              PDF
                            </Button>}
                            content={() => componentRef.current}
                            pageStyle={getPageMargins()}
                          />
                          <div hidden={true}>
                            <CreatePDF ref={componentRef}
                              earlySettledLoanList={earlySettledLoanList} 
                              searchData={selectedSearchValues}
                              dateRange={DateRange}

                            />
                          </div>
                        </Box> : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
      </Page>
    </Fragment>
  );
}
